import script from "./DateRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRange.vue?vue&type=script&setup=true&lang=ts"

import "./DateRange.vue?vue&type=style&index=0&id=99a86d5a&lang=css"

const __exports__ = script;

export default __exports__